import PropTypes from "prop-types";
import { Avatar } from "@mui/material";
import "./profileHeader.scss";

const ProfileHeader = ({ currentUser }) => {
  // Check if currentUser exists before rendering content
  if (!currentUser) {
    return <div>Loading user data...</div>;
  }

  return (
    <div className="ProfileHeader flex flex-col items-center pt-5">
      <div className="flex flex-col  items-center space-y-1">
        {currentUser.empAvatar ? (
          <Avatar
            src={currentUser.empAvatar}
            alt="avatar"
            sx={{ width: 200, height: 200 }}
            className="rotate-image"
          />
        ) : (
          <Avatar
            src="/puritynailbar_svg.png"
            alt="avatar"
            sx={{ width: 200, height: 200 }}
            className="rotate-image"
          />
        )}

        <h1 className="profile-name">{currentUser.empName}</h1>
      </div>
      <div className="settings-icon text-[10px] text-gray-500 ">
        {currentUser.empEmail}
      </div>
    </div>
  );
};

ProfileHeader.propTypes = {
  currentUser: PropTypes.shape({
    empAvatar: PropTypes.string.isRequired, // URL for the avatar image
    empName: PropTypes.string.isRequired, // User's name
    empEmail: PropTypes.string.isRequired, // User's email
  }).isRequired,
};

export default ProfileHeader;
